import { constants } from './constants';

export const generateNoticeTextByMitigationType = (tla, dp, atz, mitigationAction, currencySymbol, structuredTexts) => {
  let mitigationType;
  let noticeText;
  const mtgTypes = constants.MITIGATION_TYPES;

  if (parseFloat(tla) > 0 && parseFloat(dp) === 0) {
    const texts = structuredTexts.AUTHORIZE;
    mitigationType = mtgTypes.AUTHORIZE;
    noticeText = texts.ACTIVATION_NOTICE;
  }
  if (parseFloat(tla) > 0 && parseFloat(dp) > 0) {
    const texts = structuredTexts.AUTHORIZE_WITH_DP;
    mitigationType = mtgTypes.AUTHORIZE_WITH_DP;
    noticeText = texts.ACTIVATION_NOTICE.replace('{currency+amount}', currencySymbol + Math.round(dp));
  }
  if (parseFloat(dp) > 0 && parseFloat(dp) === parseFloat(atz)) {
    const texts = structuredTexts.DP;
    mitigationType = mtgTypes.DOWN_PAYMENT;
    noticeText = texts.ACTIVATION_NOTICE.replace('{currency+amount}', currencySymbol + Math.round(dp));
  }
  if (mitigationAction === 'verify') {
    const texts = structuredTexts.VERIFY;
    mitigationType = mtgTypes.VERIFY;
    noticeText = texts.ACTIVATION_NOTICE;
  }

  return noticeText;
};

export const convertTextsToStructuredFormat = (inputTexts) => {
  return {
    ENSURE: inputTexts.ensure,
    SETUP_DISCLAIMER: [inputTexts.setup_disclaimer_1, inputTexts.setup_disclaimer_2],
    AUTHORIZE: {
      ACTIVATION_NOTICE: inputTexts.authorize_activation_notice,
    },
    AUTHORIZE_WITH_DP: {
      ACTIVATION_NOTICE: inputTexts.authorize_with_dp_activation_notice,
    },
    DP: {
      ACTIVATION_NOTICE: inputTexts.dp_activation_notice,
    },
    VERIFY: {
      ACTIVATION_NOTICE: inputTexts.verify_activation_notice,
    },
    BUSINESS_TERMS: {
      FIXED_AMOUNT: [inputTexts.business_terms_fixed_amount_1, inputTexts.business_terms_fixed_amount_2],
      MIN_INSTALLMENT: [inputTexts.business_terms_min_installment_1, inputTexts.business_terms_min_installment_2],
      MIN_INSTALLMENT_PLUS_CPT: [
        inputTexts.business_terms_min_installment_plus_cpt_1,
        inputTexts.business_terms_min_installment_plus_cpt_2,
      ],
      FIXED_PAYMENT_PLAN: [
        inputTexts.business_terms_fixed_payment_plan_1,
        inputTexts.business_terms_fixed_payment_plan_2,
      ],
      FULL_DOWN_PAYMENT: [
        inputTexts.business_terms_full_down_payment_1,
        inputTexts.business_terms_full_down_payment_2,
        inputTexts.business_terms_full_down_payment_3,
      ],
      ADVANCE_PAYMENTS: [
        inputTexts.business_terms_advance_payments_1,
        inputTexts.business_terms_advance_payments_2,
      ],
    },
    OFFER_DESCRIPTIONS: {
      MCA: inputTexts.offer_descriptions_mca,
      MCA_WITH_MIN: inputTexts.offer_descriptions_mca_with_min,
      FIXED: inputTexts.offer_descriptions_fixed,
      MIN_INSTALLMENT: [
        inputTexts.offer_descriptions_min_installment_1,
        inputTexts.offer_descriptions_min_installment_2,
      ],
      MIN_INSTALLMENT_PLUS_CPT: [
        inputTexts.offer_descriptions_min_installment_plus_cpt_1,
        inputTexts.offer_descriptions_min_installment_plus_cpt_2,
      ],
    },
  };
};

export const setProductType = (productId) => {
  const fixedPaymentProducts = [
    constants.PRODUCT_IDS.FIXED_PAYMENT,
    constants.PRODUCT_IDS.CALCULATED_FIXED_PAYMENT,
    constants.PRODUCT_IDS.MCA_WITH_MIN,
    constants.PRODUCT_IDS.MCA_PLUS_CPT_WITH_MIN,
    constants.PRODUCT_IDS.FIXED_PAYMENT_PLAN,
  ];
  let isPaymentProduct = false;
  if (fixedPaymentProducts.includes(parseInt(productId))) {
    isPaymentProduct = true;
  }
  return isPaymentProduct;
};

export const convertFromNumberToText = (cycle) => {
  let cycleText;
  switch (cycle) {
    case 1:
      cycleText = 'day';
      break;
    case 7:
      cycleText = 'week';
      break;
    case 14:
      cycleText = 'two-weeks';
      break;
    case 28 || 30 || 31:
      cycleText = 'month';
      break;
    default:
      cycleText = '';
  }
  return cycleText;
};

export const convertFromNumberToPeriod = (numOfDays) => {
  numOfDays = parseInt(numOfDays);
  let numOfDaysText;
  switch (numOfDays) {
    case 1:
      numOfDaysText = 'daily';
      break;
    case 7:
      numOfDaysText = 'weekly';
      break;
    case 14:
      numOfDaysText = 'bi-monthly';
      break;
    case 28 || 30 || 31:
      numOfDaysText = 'monthly';
      break;
    default:
      numOfDaysText = '';
  }
  return numOfDaysText;
};
